import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";

const SiteMediaContext = createContext({ m: (_k, f) => f, map: {} });
export const useSiteMedia = () => useContext(SiteMediaContext);

export const SiteMediaProvider = ({ children }) => {
  const [map, setMap] = useState({});
  useEffect(() => {
    api.get("/site-media").then((r) => setMap(r.data)).catch((err) => console.error("Failed to load site media", err));
  }, []);
  const value = useMemo(() => ({ m: (key, fallback = "") => map[key] || fallback, map }), [map]);
  return <SiteMediaContext.Provider value={value}>{children}</SiteMediaContext.Provider>;
};
